/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-unused-expressions */
import {
  IconFont,
  SignTitle,
  SearchInput,
  TableTag,
  STreeSelect,
  TagSearchOption,
} from '@/components'
import { Dispaths } from '@/types'
import { disabledDate, disabledDateTime } from '@/utils/appointment'
import { useDebounceFn, useSelections } from 'ahooks'
import Scrollbars from 'react-custom-scrollbars'
import {
  Button,
  Space,
  Form,
  Input,
  DatePicker,
  Card,
  Select,
  TimePicker,
  TreeSelect,
  Checkbox,
  Typography,
  message,
  Empty,
  InputNumber,
  Row,
  Col,
  Cascader,
  Tooltip,
} from 'antd'
const { Option } = Select
import React, { useContext, useEffect, useMemo } from 'react'
import { useState } from 'react'
import styled from 'styled-components'
import { ArticleSteps } from '@/components/article-steps'
import { Configuration, EscapeMode, PreviewContent, TaskNameRight } from './create-right'
import { useNavigate } from 'react-router'
import Modecard from '@/assets/imges/data-protection/modecard.png'
import { TemplateParticulars } from './template-particulars'
import {
  useCreateTask,
  useGetTplList,
  useTargetList,
  useTaskTemplate,
  useGetTagTreeOptions,
} from './utils'
import { GetTplList } from '@/api/data-protection/create'
import EmptyImg from '@/assets/imges/Empty/Empty.png'
import moment from 'moment'
import { Message } from '@/components/message'
import { useAppSelector } from '@/redux/hooks'
import { isTimeInRange } from '@/redux/taskSlice'
import { t } from '@/i18n'
const { useForm } = Form
const TaskName = () => {
  const [form] = useForm()
  const [searchForm] = useForm()
  const { dispatch, data } = useCreateTaskContext()
  const [getTagTreeOptions, tagTreeOptions] = useGetTagTreeOptions()
  const { submitData } = data
  const { setSteps, setSubmitData } = dispatch
  let [execute, setExecute] = useState(submitData?.executionType || 1)
  const [getTarget, targetList] = useTargetList()
  const [tplParams, setTplParams] = useState<GetTplList>({})
  const [getTplList, tplList] = useGetTplList({ GetTplParams: tplParams })
  const [particulars, setParticulars] = useState({ visible: false, id: null })
  const [activeTemplate, setActiveTemplate] = useState<any>(submitData.template)
  let [taskTime, setTaskTime] = useState(submitData?.taskTime || null)
  let [dayOfWeek, setDayOfWeek] = useState<any>(submitData.dayOfWeek || null)

  const [isPause, setIsPause] = useState(false)
  const isAll = useAppSelector(state => state.task.isAll)
  const pauseEnabled = useAppSelector(state => state.task.pauseEnabled)
  const pauseWeek = useAppSelector(state => state.task.pauseWeek)
  const startTime = useAppSelector(state => state.task.startTime)
  const endTime = useAppSelector(state => state.task.endTime)
  const submitHandler = (values: any) => {
    // console.log(values)

    const { name, securityDomain, dispose, timeout } = values

    setSubmitData(origin => ({
      ...origin,
      client: securityDomain[1],
      name: name,
      dispose: dispose,
      template: { ...origin.template, ...activeTemplate },
      executionType: execute,
      dayOfWeek: dayOfWeek,
      taskTime: taskTime,
      agent: targetList
        .filter(item => item.data)
        .map(v => v.data.find(it => it.host_id === values.securityDomain[1]))
        .filter(item => item !== undefined)
        .find(item => item.host_id === values.securityDomain[1]),
      business: securityDomain[0],
      timeout: timeout,
    }))
    if ((execute > 1 && !taskTime) || (execute > 3 && !dayOfWeek)) {
      Message.error(t('请选择时间'))
      return
    }
    setSteps(2)
  }
  const navigate = useNavigate()
  const treeData = [
    {
      title: t('周一'),
      value: '1',
    },
    {
      title: t('周二'),
      value: '2',
    },
    {
      title: t('周三'),
      value: '3',
    },
    {
      title: t('周四'),
      value: '4',
    },
    {
      title: t('周五'),
      value: '5',
    },
    {
      title: t('周六'),
      value: '6',
    },
    {
      title: t('周日'),
      value: '0',
    },
  ]
  const { run: changeValue } = useDebounceFn(
    (e: string) => {
      console.log('e', e)
      setTplParams(origin => ({
        ...origin,
        resource_tag_ids: searchForm
          .getFieldsValue()
          ?.resource_tag_ids?.map(item => item.split('$').slice(1).join('$')),
        keyword: searchForm.getFieldsValue()?.keyword,
      }))
      setTemplateList([])
    },
    {
      wait: 500,
    },
  )
  const monthList = useMemo(() => {
    let arrMonth = []
    for (let i = 1; i < 32; i++) {
      arrMonth.push({
        title: `${i}${t('号')}`,
        value: i.toString(),
      })
    }
    return arrMonth
  }, [])

  const [templateList, setTemplateList] = useState([])
  useEffect(() => {
    form.setFieldValue('securityDomain', submitData?.securityDomain)
    getTagTreeOptions({}).catch(err => console.log(err))
    // 未开启
    if (!pauseEnabled) {
      setIsPause(false)
      return
    }

    // 全时段暂停
    if (isAll) {
      setIsPause(true)
      return
    }

    // 自定义暂停
    const week = moment().day()
    const current = {
      hour: moment().hours(),
      minute: Number(moment().format('hh:mm:ss').split(':')[1]),
      second: Number(moment().format('hh:mm:ss').split(':')[2]),
    }

    // 非暂停时间段 (天）
    if (!pauseWeek.includes(week)) {
      setIsPause(false)
      return
    } else {
      // 非暂停时间段 (时分秒)
      if (!isTimeInRange(current, startTime, endTime)) {
        setIsPause(false)
        return
      }
      setIsPause(true)
    }
  }, [])

  useEffect(() => {
    if (tplList?.items?.length > 0) {
      let arr = []
      templateList?.map(item => {
        arr.push(item)
      })
      tplList?.items?.map((item: any) => {
        arr.push(item)
      })
      setTemplateList(arr)
    }
  }, [tplList])

  return (
    <ModalContent>
      <div className="body">
        <Form
          form={form}
          onFinish={submitHandler}
          layout={'vertical'}
          style={{ width: '100%' }}
          initialValues={{
            option: 1,
            name: submitData.name,
            securityDomain: undefined,
            dispose: submitData.dispose,
            timeout: submitData.timeout,
          }}
        >
          <div className="tasks-background" style={{ marginBottom: 16 }}>
            <div className="item">
              <Form.Item
                label={t('任务名称')}
                name="name"
                rules={[{ required: true }, { max: 50, message: t('任务名称最多50字') }]}
                style={{ width: '100%', marginRight: '4%' }}
              >
                <Input placeholder={t('请输入任务名称')} />
              </Form.Item>
            </div>
            <div className="item" style={{ justifyContent: 'center' }}>
              <Form.Item
                label={t('执行类型')}
                name="option"
                rules={[{ required: true }]}
                style={{ width: '100%' }}
              >
                <Input.Group compact style={{ display: 'flex' }}>
                  <Select
                    defaultValue={execute}
                    onChange={e => {
                      setExecute((execute = e))
                      setDayOfWeek(null)
                      setTaskTime(null)
                    }}
                  >
                    <Option value={1}>{t('立即')}</Option>
                    <Option value={2}>{t('预定')}</Option>
                    <Option value={3}>{t('每日')}</Option>
                    <Option value={4}>{t('每周')}</Option>
                    <Option value={5}>{t('每月')}</Option>
                  </Select>
                  {execute === 1 && (
                    <div
                      style={{
                        color: '#333333',
                        paddingLeft: '12px',
                        width: '78%',
                        border: '1px solid #d9d9d9',
                        background: '#fff',
                        lineHeight: '28px',
                      }}
                    >
                      <span>{t('立即执行')}</span>
                    </div>
                  )}
                  {execute === 2 && (
                    <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                      <DatePicker
                        placeholder={t('请选择日期与时间')}
                        style={{ width: '95%', fontSize: '14px', borderRadius: '0 6px 6px 0' }}
                        showTime
                        onChange={(value, dateString) => {
                          setTaskTime((taskTime = dateString))
                        }}
                        defaultValue={taskTime ? moment(taskTime) : null}
                        disabledDate={disabledDate}
                        disabledTime={disabledDateTime}
                      />
                    </div>
                  )}
                  {execute === 3 && (
                    <div
                      style={{
                        display: 'flex',
                        borderRadius: '0 6px 6px 0',
                        alignItems: 'center',
                        width: '100%',
                      }}
                    >
                      <TimePicker
                        style={{ width: '95%', borderRadius: '0 6px 6px 0' }}
                        defaultValue={taskTime ? moment(taskTime, 'HH/mm/ss') : null}
                        onChange={(value, dateString) => {
                          setTaskTime((taskTime = dateString))
                        }}
                      />
                    </div>
                  )}
                  {execute === 4 && (
                    <Input.Group compact>
                      <div className="date-select" style={{ width: '55%' }}>
                        <TreeSelect
                          treeData={treeData}
                          treeCheckable
                          showCheckedStrategy="SHOW_PARENT"
                          style={{ width: '100%', borderRadius: '0', textAlign: 'left' }}
                          placeholder={t('请选择星期')}
                          defaultValue={dayOfWeek?.split(',')}
                          maxTagCount={1}
                          onChange={(week: any) => {
                            setDayOfWeek((dayOfWeek = week.join(',')))
                          }}
                        />
                      </div>
                      <TimePicker
                        style={{ width: '40%', borderRadius: '0 6px 6px 0' }}
                        defaultValue={taskTime ? moment(taskTime, 'HH/mm/ss') : null}
                        onChange={(value, dateString) => {
                          setTaskTime((taskTime = dateString))
                        }}
                      />
                    </Input.Group>
                  )}
                  {execute === 5 && (
                    <Input.Group compact>
                      <div className="date-select" style={{ width: '55%' }}>
                        <TreeSelect
                          treeData={monthList}
                          treeCheckable
                          defaultValue={dayOfWeek?.split(',')}
                          key="value"
                          showCheckedStrategy="SHOW_PARENT"
                          placeholder={t('请选择日期')}
                          maxTagCount={1}
                          style={{ width: '100%', borderRadius: '0' }}
                          onChange={(month: any) => {
                            setDayOfWeek((dayOfWeek = month.join(',')))
                          }}
                        />
                      </div>
                      <TimePicker
                        placeholder={t('选择时间')}
                        style={{ width: '40%', borderRadius: '0 6px 6px 0' }}
                        defaultValue={taskTime ? moment(taskTime, 'HH/mm/ss') : null}
                        onChange={(value, dateString) => {
                          setTaskTime((taskTime = dateString))
                        }}
                      />
                    </Input.Group>
                  )}
                </Input.Group>
              </Form.Item>
            </div>
            <div className="item" style={{ justifyContent: 'flex-end' }}>
              <Form.Item
                label={t('客户端')}
                name="securityDomain"
                rules={[{ required: true, message: t('请选择客户端') }]}
                style={{ width: '95%' }}
              >
                <Cascader
                  placeholder={t('安全域/客户端列表')}
                  options={targetList
                    ?.filter(item => !(item.id === '-2' && item.data.length === 0))
                    ?.map(v => ({
                      label: v.name,
                      value: v.id,
                      children: v.data.map(it => ({
                        label: it.target,
                        value: it.host_id,
                      })),
                    }))}
                  dropdownRender={menu => <>{menu}</>}
                />
              </Form.Item>
            </div>
            <div className="item" style={{ marginLeft: '12px' }}>
              <Form.Item
                label={t('上传超时（5-120s）')}
                name={'timeout'}
                style={{ width: '96%', marginLeft: '-12px' }}
                validateFirst
                rules={[
                  { required: true, message: t('请输入上传超时时间') },
                  () => ({
                    validator(_, value) {
                      if (value >= 5 && value <= 120) {
                        return Promise.resolve()
                      }
                      return Promise.reject(new Error(t('上传超时为5-120s')))
                    },
                  }),
                ]}
                initialValue={5}
              >
                <InputNumber style={{ width: '100%' }} type="number" />
              </Form.Item>
            </div>
          </div>
        </Form>
        <div style={{ height: 'calc(100% -  200px)', minHeight: '200px' }}>
          <SignTitle>
            <span style={{ color: '#F53F3F' }}>*</span>
            <span>{t('模板选择')}</span>
          </SignTitle>
          <Form
            initialValues={{ keyword: '', resource_tag_ids: [] }}
            form={searchForm}
            onValuesChange={val => {
              changeValue(val)
            }}
            layout="horizontal"
          >
            <Row
              gutter={0}
              style={{
                marginTop: 12,
                marginBottom: 16,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
              }}
            >
              <span style={{ display: 'inline-block', marginRight: 20 }}>
                <Form.Item name={'keyword'} noStyle>
                  <Input
                    style={{ width: 230, height: 32 }}
                    placeholder={t('请输入模板名称')}
                    prefix={
                      <IconFont type="icon-sousuo1" style={{ color: '#666', fontSize: 16 }} />
                    }
                  />
                </Form.Item>
              </span>
              <span style={{ display: 'inline-block' }} className="s-tree-select">
                <STreeSelect
                  style={{ width: 230, height: 32, marginBottom: 0 }}
                  onChange={val => {}}
                  option={{
                    label: t('用例标签'),
                    name: 'resource_tag_ids',
                    type: 'treeSelect',
                    typeof: 'array',
                    data: TagSearchOption(tagTreeOptions),
                  }}
                />
              </span>
              <span>
                <Button
                  type="link"
                  onClick={() => {
                    changeValue({ keyword: '', resource_tag_ids: [] })
                    searchForm.resetFields()
                  }}
                >
                  {t('重置')}
                </Button>
              </span>
            </Row>
          </Form>
          <div
            style={{
              position: 'absolute',
              top: 330,
              left: 0,
              width: '100%',
              borderTop: '1px dashed #ccc',
            }}
          />
          <div style={{ height: 1, marginBottom: 14 }} />
          <Scrollbars style={{ height: 'calc(100% - 100px)' }}>
            <TemplateSelect>
              {templateList?.map(item => (
                <div
                  className="item"
                  key={item.id}
                  onClick={() => setParticulars({ visible: true, id: item.id })}
                >
                  <div className="flex">
                    <div className="flex" style={{ width: 'calc(100% - 30px)' }}>
                      {item.origin_type === 1 ? (
                        <TableTag background="#558492" color="#fff">
                          {t('系统内置')}
                        </TableTag>
                      ) : (
                        <TableTag background="#ED787E" color="#fff" style={{ padding: '3px 4px' }}>
                          {t('自定义')}
                        </TableTag>
                      )}
                      <Typography.Text
                        style={{ marginLeft: 6, width: 'calc(100% - 70px)', fontWeight: 'bold' }}
                        ellipsis={{ tooltip: item.name }}
                      >
                        {item.name}
                      </Typography.Text>
                    </div>
                    <Checkbox
                      style={{ width: 24, height: 24 }}
                      disabled={activeTemplate.id ? item.id !== activeTemplate.id : false}
                      checked={item.id === activeTemplate.id}
                      onClick={(e: any) => {
                        e.stopPropagation()
                        setSubmitData(origin => ({
                          ...origin,
                          testFile: undefined,
                          variant: undefined,
                        }))
                        if (e.target.checked) {
                          setActiveTemplate({
                            id: item.id,
                            file_type: item.file_type,
                            name: item.name,
                            file_ext: item.file_ext,
                          })
                          return
                        }
                        setActiveTemplate({})
                      }}
                      onChange={e => {}}
                    />
                  </div>
                  <div className="item-main">
                    <div className="item-img">
                      <img
                        width={48}
                        height={48}
                        src={`${process.env.NODE_ENV === 'dev' ? '/api' : ''}${item.cover}`}
                        alt=""
                      />
                    </div>
                    <div className="item-right">
                      <div className="analysis">
                        {item.file_type <= 3 ? t('可解析') : t('不可解析')}
                      </div>
                      <div className="bmp">
                        <Typography.Text ellipsis={{ tooltip: true }}>
                          {item.file_name}
                        </Typography.Text>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </TemplateSelect>
            {templateList.length === 0 && <Empty image={EmptyImg} />}
          </Scrollbars>
        </div>
        <TemplateParticulars particulars={particulars} setParticulars={setParticulars} type={2} />
      </div>
      <div className="footer">
        {activeTemplate.id ? (
          <ArticleSteps
            currentNum={0}
            length={activeTemplate?.file_type <= 3 ? 4 : 3}
            style={{ width: 150 }}
          />
        ) : (
          <div />
        )}
        <Space>
          <Tooltip
            title={isPause && t('当前时间属于任务暂停时间段，无法创建任务')}
            placement="topRight"
          >
            <Button type={'primary'} onClick={form.submit} disabled={!activeTemplate.id || isPause}>
              {t('下一步')}
            </Button>
          </Tooltip>
        </Space>
      </div>
    </ModalContent>
  )
}
const DataContent = () => {
  const { dispatch, data } = useCreateTaskContext()
  const [form] = useForm()
  const { submitData } = data
  // console.log(submitData)

  const { setSteps, setSubmitData } = dispatch
  const [getTaskTemplate, taskTemplateData] = useTaskTemplate()
  const { selected, isSelected, toggle } = useSelections([1, 2, 3], submitData.testFile || [])
  const [taskTemplate, setTaskTemplate] = useState('')
  const Rmvb =
    submitData.template.file_type === 1
      ? submitData.template.file_ext === '.xlsx' || submitData.template.file_ext === '.xls'
        ? [
            { id: 4, name: 'XLS' },
            { id: 5, name: 'XLSX' },
          ]
        : [
            { id: 2, name: 'DOCX' },
            { id: 3, name: 'PDF' },
          ]
      : [
          { id: 1, name: 'TXT' },
          { id: 2, name: 'DOCX' },
          { id: 3, name: 'PDF' },
        ]
  useEffect(() => {
    if (submitData.template?.id) {
      getTaskTemplate({ id: submitData.template?.id })
        .then(res => {
          setTaskTemplate(res.data?.content)
          onCheckVariable(res.data?.content)
        })
        .catch(_ => {})
    }
  }, [submitData.template?.id])
  const onFinish = values => {
    // let str = JSON.parse(JSON.stringify(taskTemplate))
    let replace_dict = {}
    Object.keys(values)?.map(item => {
      replace_dict[`{{${item}}}`] = values[item]
    })
    setSubmitData(origin => ({
      ...origin,
      testFile: selected.sort(),
      template: {
        ...origin.template,
        replace_dict: replace_dict,
        dynamic_dict: taskTemplateData?.dynamic_dict,
      },
      variant: values,
    }))
    setSteps(submitData.template?.file_type < 4 ? 3 : 2)
  }
  const variablesWithInterpretation = [
    { name: 'name_en', value: t('随机英文名字') },
    { name: 'name_cn', value: t('随机中文名字') },
    { name: 'idcard', value: t('随机身份证号') },
    { name: 'bankno', value: t('随机银行卡号') },
    { name: 'phoneno', value: t('随机手机号') },
    { name: 'gender', value: t('随机性别') },
    { name: 'email', value: t('随机邮箱') },
    { name: 'email_account', value: t('生成与当前用户同域的随机邮箱') },
    { name: 'ip_ext', value: t('随机外网ip') },
    { name: 'ip_inter', value: t('随机内网ip') },
    { name: 'HKCardNo', value: t('港澳居民来往内地通行证') },
    { name: 'TWCardNo', value: t('台湾身份证') },
    { name: 'OfficerNo', value: t('军官证') },
    { name: 'AccountNo', value: t('户口本号') },
    { name: 'PassportNo', value: t('护照号码') },
    { name: 'DriverLicenseNo', value: t('驾驶证') },
  ]
  const [variables, setVariables] = useState([])
  const onCheckVariable = (fileData: string) => {
    // 检测变量
    let r = []
    let inBrace = false
    let variable = ''
    for (let i = 0; i < fileData.length; i++) {
      let char = fileData[i]
      let next = ''
      if (i < fileData.length) {
        next = fileData[i + 1]
      }
      if (char == '{' && next == '{') {
        i += 1
        inBrace = true
        continue
      }
      if (inBrace && char !== '}') {
        variable += char
        continue
      }
      if (char == '}' && next === '}') {
        if (inBrace && !r.includes(variable)) {
          r.push(variable)
        }
        i += 1
        inBrace = false
        variable = ''
      }
    }
    const list = variablesWithInterpretation.map(item => item.name)
    let result = r.filter(item => list.includes(item))
    setVariables(result)
  }
  return (
    <ModalContent>
      <DataContentTemplate>
        <div className="content">
          <div className="left">
            <div className="title">{t('数据内容预览')}</div>
            <div className="left-content">
              <div style={{ position: 'absolute', lineHeight: 1.2 }}>{taskTemplate}</div>
            </div>
          </div>
          <div className="right">
            <div className="title">
              <span style={{ color: '#F53F3F' }}>*</span> {t('替换变量值')}
            </div>
            <div className="right-content">
              <Form
                form={form}
                onFinish={onFinish}
                layout="horizontal"
                initialValues={submitData?.variant}
              >
                {variables?.map((item, index) => (
                  <Form.Item
                    label={item}
                    name={item}
                    key={index}
                    rules={[
                      { required: true },
                      { max: 50 },
                      (item === 'email' || item === 'email_account') && {
                        type: 'email',
                        message: t('请输入正确的邮箱'),
                      },
                      (item === 'ip_ext' || item === 'ip_inter') && {
                        pattern:
                          /^((2((5[0-5])|([0-4]\d)))|([0-1]?\d{1,2}))(\.((2((5[0-5])|([0-4]\d)))|([0-1]?\d{1,2}))){3}$/,
                        message: t('请输入正确的IP地址'),
                      },
                      item === 'phoneno' && {
                        pattern: /^1[3-9]\d{9}$/,
                        message: t('请输入正确的手机号'),
                      },
                    ]}
                  >
                    <Input placeholder={t('请输入')} />
                  </Form.Item>
                ))}
              </Form>
            </div>
          </div>
        </div>
        <div className="content-footer">
          <div className="title">
            <span style={{ color: '#F53F3F' }}>*</span>
            {t('可测试的文件格式')}
          </div>
          <div className="footer-main">
            {Rmvb.map(item => (
              <BmpButton key={item.id} onClick={() => toggle(item.id)} active={isSelected(item.id)}>
                {item.name}
              </BmpButton>
            ))}
          </div>
        </div>
      </DataContentTemplate>
      <div className="footer">
        <ArticleSteps currentNum={1} length={4} style={{ width: 180 }} />
        <Space>
          <Button
            onClick={async () => {
              try {
                setSteps(origin => origin - 1)
              } catch (error) {}
            }}
          >
            {t('上一步')}
          </Button>
          <Button type={'primary'} onClick={form.submit} disabled={selected.length === 0}>
            {t('下一步')}
          </Button>
        </Space>
      </div>
    </ModalContent>
  )
}
const Leakage = () => {
  const { dispatch, data } = useCreateTaskContext()
  const [form] = useForm()
  const { submitData } = data
  const { setSteps, setSubmitData } = dispatch
  const compress = [
    { id: 1, name: 'ZIP' },
    { id: 2, name: '7z' },
    { id: 3, name: 'tar' },
    { id: 4, name: 'gz' },
    { id: 5, name: t('zip加密') },
    { id: 6, name: t('7z加密') },
    // { id: 7, name: 'tar加密' },
    // { id: 7, name: 'gz加密' },
  ]
  const escape = [
    { id: 'HTTP', name: 'HTTP' },
    { id: 'HTTPS', name: 'HTTPS' },
    { id: 'Git', name: 'Git' },
    // { id: 'Email', name: 'Email' },
    // { id: 'SVN', name: 'SVN' },
  ]
  const SelectTemplate = useMemo(() => {
    let arr = []
    arr.push(...compress.map(item => item.id), ...escape.map(item => item.id))
    return arr
  }, [])
  const { selected, isSelected, toggle } = useSelections(
    SelectTemplate,
    [...(submitData?.zipNested || ''), ...(submitData?.leakage || '')] || [],
  )
  useEffect(() => {
    if (!selected?.filter(item => item > 4)[0] && form.getFieldValue('password')) {
      form.resetFields()
    }
    if (form.getFieldValue('password') && selected.length === 0) {
      form.resetFields()
    }
  }, [selected])
  const onFinish = values => {
    const { password } = values
    let zip = []
    let leakage = []
    selected.map(item => {
      if (typeof item === 'string') {
        leakage.push(item)
      } else {
        zip.push(item)
      }
    })
    if ((isSelected(5) || isSelected(6) || isSelected(7)) && !password) {
      Message.error(t('请输入加密密码'))
      return
    }
    if (leakage.length === 0) {
      Message.error(t('请选择外泄途径'))
      return
    }
    setSubmitData(origin => ({ ...origin, zipNested: zip.sort(), leakage, password }))
    setSteps(submitData.template?.file_type < 4 ? 4 : 3)
  }

  return (
    <ModalContent>
      <LeakageTemplate>
        <div className="left">
          <div className="title">{t('压缩嵌套')}</div>
          <div className="content">
            <div className="compress-mode">
              {compress.map(item => (
                <BmpButton
                  key={item.id}
                  onClick={() => toggle(item.id)}
                  active={isSelected(item.id)}
                >
                  {item.name}
                </BmpButton>
              ))}
            </div>
            <div className="content-footer">
              <Form
                layout="vertical"
                form={form}
                onFinish={onFinish}
                initialValues={{ password: submitData.password || undefined }}
              >
                <Form.Item label={t('加密密码')} name="password" style={{ width: '100%' }}>
                  <Input
                    placeholder={t('未使用压缩加密')}
                    disabled={!selected?.some(item => item > 4)}
                  />
                </Form.Item>
              </Form>
            </div>
          </div>
        </div>
        <div className="right">
          <div className="title">
            <span style={{ color: '#F53F3F' }}>*</span> {t('外泄途径')}
          </div>
          <div className="content">
            <div className="compress-mode">
              {escape.map(item => (
                <BmpButton
                  key={item.id}
                  onClick={() => toggle(item.id)}
                  active={isSelected(item.id)}
                >
                  {item.name}
                </BmpButton>
              ))}
            </div>
          </div>
        </div>
      </LeakageTemplate>
      <div className="footer">
        <ArticleSteps
          currentNum={submitData.template?.file_type <= 3 ? 2 : 1}
          length={submitData.template?.file_type <= 3 ? 4 : 3}
          style={{ width: 180 }}
        />
        <Space>
          <Button
            onClick={async () => {
              try {
                let zip = []
                let leakage = []
                selected.map(item => {
                  if (typeof item === 'string') {
                    leakage.push(item)
                  } else {
                    zip.push(item)
                  }
                })
                setSubmitData(origin => ({ ...origin, zipNested: zip.sort(), leakage }))
                setSteps(origin => origin - 1)
              } catch (error) {}
            }}
          >
            {t('上一步')}
          </Button>
          <Button type={'primary'} onClick={() => form.submit()}>
            {t('下一步')}
          </Button>
        </Space>
      </div>
    </ModalContent>
  )
}
const TaskOverview = () => {
  const { dispatch, data } = useCreateTaskContext()
  const navigate = useNavigate()
  const [createTask, createTaskLoading] = useCreateTask()
  const {
    submitData: {
      agent,
      name,
      template,
      executionType,
      testFile,
      zipNested,
      leakage,
      dispose,
      taskTime,
      dayOfWeek,
      password,
      timeout,
    },
  } = data
  const Leak = useMemo(() => {
    let arr = []
    leakage?.map(item => {
      switch (item) {
        case 'HTTP':
          arr.push(1)
          break
        case 'HTTPS':
          arr.push(2)
          break
        case 'Git':
          arr.push(3)
          break
        case 'Email':
          arr.push(4)
          break
        case 'SVN':
          arr.push(5)
          break
      }
    })
    return arr.sort()
  }, [])
  const { setSteps, setSubmitData } = dispatch
  const onFinish = async () => {
    console.log('12321312', {
      name: name,
      biz_area_name: agent?.biz_area_name,
      scheduler_type: executionType,
      task_time: taskTime,
      days: executionType !== 4 ? dayOfWeek : undefined,
      day_of_week: executionType === 4 ? dayOfWeek : undefined,
      template_id: template?.id,
      action_list: dispose,
      replace_dict: template?.replace_dict,
      dynamic_dict: template?.dynamic_dict,
      compress_password: password,
      agent_id: agent.agent_id,
      hostname: agent.hostname,
      host_id: agent.host_id,
      file_format_list: testFile,
      compress_type_list: zipNested,
      leak_type_list: Leak,
      file_type: template.file_type,
      timeout: timeout,
    })
    try {
      await createTask({
        name: name,
        biz_area_name: agent?.biz_area_name,
        scheduler_type: executionType,
        task_time: taskTime,
        days: executionType !== 4 ? dayOfWeek : undefined,
        day_of_week: executionType === 4 ? dayOfWeek : undefined,
        template_id: template?.id,
        action_list: dispose,
        replace_dict: template?.replace_dict,
        dynamic_dict: template?.dynamic_dict,
        compress_password: password,
        agent_id: agent.agent_id,
        hostname: agent.hostname,
        host_id: agent.host_id,
        file_format_list: testFile,
        compress_type_list: zipNested,
        leak_type_list: Leak,
        file_type: template.file_type,
        timeout: timeout,
      })
      navigate('/validation/data/dataprotection?tab=task')
    } catch (error) {}
  }

  return (
    <ModalContent>
      <OverviewTemplate cover={Modecard}>
        <div className="overview">
          <div className="flex">
            <div className="title">{t('任务名称：')}</div>
            <div className="text">{name}</div>
          </div>
          <div className="flex">
            <div className="title">{t('安全域：')}</div>
            <div className="text">{agent?.biz_area_name}</div>
          </div>
          {/* <div className="flex">
            <div className="title">处置动作：</div>
            <div className="text">阻断</div>
          </div> */}
          <div className="flex">
            <div className="title">{t('任务模板：')}</div>
            <div className="text">{template?.name}</div>
          </div>
          <div className="flex">
            <div className="title">{t('客户端：')}</div>
            <div className="text">{agent?.hostname}</div>
          </div>
          <div className="flex">
            <div className="title">{t('上传超时：')}</div>
            <div className="text">
              {timeout ? (
                <span>
                  {timeout}
                  {t('秒')}
                </span>
              ) : (
                <span />
              )}
            </div>
          </div>
          <div className="flex">
            <div className="title">{t('执行类型：')}</div>
            <div className="text">
              {executionType === 1 && t('立即')}
              {executionType === 2 && t('预定')}
              {executionType === 3 && t('每日')}
              {executionType === 4 && t('每周')}
              {executionType === 5 && t('每月')}
            </div>
          </div>
        </div>
        <div style={{ marginBottom: 16 }}>{t('外泄方式')}</div>
        <div className="leakage">
          {/* <img src={Modecard} alt="" /> */}
          <div className="leakage-left">
            <div className="title">{t('文件格式')}</div>
            <div className={testFile?.length > 0 ? 'leakage-context' : 'leakage-empty'}>
              {testFile?.map(item => (
                <TableTag bgColor="#C6CAEE" background="#fff" key={item}>
                  {item === 1 && 'TXT'}
                  {item === 2 && 'DOCX'}
                  {item === 3 && 'PDF'}
                  {item === 4 && 'XLS'}
                  {item === 5 && 'XLSX'}
                </TableTag>
              )) || <div>{t('无')}</div>}
            </div>
          </div>
          <div className="leakage-center">
            <div className="title">{t('压缩嵌套')}</div>
            <div className={zipNested?.length > 0 ? 'leakage-context' : 'leakage-empty'}>
              {zipNested?.map(item => (
                <TableTag bgColor="#C6CAEE" background="#fff" key={item}>
                  {item === 1 && 'ZIP'}
                  {item === 2 && '7z'}
                  {item === 3 && 'tar'}
                  {item === 4 && 'gz'}
                  {item === 5 && t('zip加密')}
                  {item === 6 && t('7z加密')}
                  {/* {item === 7 && 'gz加密'} */}
                </TableTag>
              ))}
              {zipNested?.length === 0 && <div>{t('无')}</div>}
            </div>
          </div>
          <div className="leakage-right">
            <div className="title">{t('外泄途径')}</div>
            <div className="leakage-context">
              {Leak?.map(item => (
                <TableTag bgColor="#C6CAEE" background="#fff" key={item}>
                  {item === 1 && 'HTTP'}
                  {item === 2 && 'HTTPS'}
                  {item === 3 && 'Git'}
                  {item === 4 && 'Email'}
                  {item === 5 && 'SVN'}
                </TableTag>
              ))}
              {leakage?.length === 0 && <div>{t('无')}</div>}
            </div>
          </div>
        </div>
      </OverviewTemplate>
      <div className="footer">
        <ArticleSteps
          currentNum={template?.file_type <= 3 ? 3 : 2}
          length={template?.file_type <= 3 ? 4 : 3}
          style={{ width: 180 }}
        />
        <Space>
          <Button
            onClick={async () => {
              try {
                setSteps(origin => origin - 1)
              } catch (error) {}
            }}
          >
            {t('上一步')}
          </Button>
          <Button type={'primary'} onClick={onFinish} loading={createTaskLoading}>
            {t('创建任务')}
          </Button>
        </Space>
      </div>
    </ModalContent>
  )
}
interface CreateTaskContextValue {
  data: {
    steps: number
    submitData: SubmitData
  }
  dispatch: {
    setSteps: Dispaths<number>
    setSubmitData: Dispaths<SubmitData>
  }
}
type ValuesType = {
  [key: string]: string | any[]
}
interface SubmitData {
  timeout: number
  start_time?: string
  name?: string
  securityDomain?: string[]
  dispose?: number
  agent?: any
  testFile?: number[]
  zipNested?: number[]
  leakage?: string[]
  dayOfWeek?: string
  taskTime?: string
  content?: string
  password?: string
  executionType?: number
  template: {
    id?: string
    file_type?: number
    replace_dict?: any
    dynamic_dict?: any
    name?: string
    file_ext: string
  }
  variant?: ValuesType
}

const createTaskContext = React.createContext<CreateTaskContextValue | null>(null)

const useCreateTaskContext = () => {
  const res = useContext(createTaskContext)
  if (res === null) {
    throw new Error(t('应在新建任务中使用该hook'))
  }
  return res
}

export const CreateTask = () => {
  const [submitData, setSubmitData] = useState<SubmitData>({
    template: {},
  })
  const [steps, setSteps] = useState(1)

  return (
    <>
      <LeftContainer
        title={
          (steps === 1 && <SignTitle>{t('基本配置')}</SignTitle>) ||
          (submitData.template?.file_type <= 3
            ? steps === 3 && <SignTitle>{t('数据外泄方式')}</SignTitle>
            : steps === 2 && <SignTitle>{t('数据外泄方式')}</SignTitle>) ||
          (submitData.template?.file_type <= 3
            ? steps === 4 && <SignTitle>{t('任务概览')}</SignTitle>
            : steps === 3 && <SignTitle>{t('任务概览')}</SignTitle>)
        }
      >
        <createTaskContext.Provider
          value={{
            data: {
              steps,
              submitData,
            },
            dispatch: {
              setSteps,
              setSubmitData,
            },
          }}
        >
          {steps === 1 && <TaskName />}
          {submitData.template?.file_type <= 3
            ? steps === 2 && <DataContent />
            : steps === 2 && <Leakage />}
          {submitData.template?.file_type <= 3
            ? steps === 3 && <Leakage />
            : steps === 3 && <TaskOverview />}
          {steps === 4 && <TaskOverview />}
        </createTaskContext.Provider>
      </LeftContainer>
      <RightContainer>
        <Scrollbars>
          <div style={{ paddingRight: 10 }}>{steps === 1 && <TaskNameRight />}</div>
          <div style={{ paddingRight: 10 }}>
            {submitData.template?.file_type <= 3
              ? steps === 2 && <PreviewContent />
              : steps === 2 && <EscapeMode />}
          </div>
          <div style={{ paddingRight: 10 }}>
            {submitData.template?.file_type <= 3
              ? steps === 3 && <EscapeMode />
              : steps === 3 && <Configuration />}
          </div>
          <div style={{ paddingRight: 10 }}>{steps === 4 && <Configuration />}</div>
        </Scrollbars>
      </RightContainer>
    </>
  )
}
const RightContainer = styled(Card)`
  min-height: 100%;
  width: 30%;
  border-radius: 8px;
  box-shadow: 0px 4px 8px 0px rgba(95, 103, 129, 0.06);
  .right-title {
    font-size: 16px;
  }
`

const LeftContainer = styled(Card)`
  position: relative;
  min-height: 100%;
  width: calc(70% - 16px);
  border-radius: 8px;
  margin-right: 16px;
  box-shadow: 0px 4px 8px 0px rgba(95, 103, 129, 0.06);
  .ant-card-body {
    height: 100%;
  }
`

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 500px;
  .s-tree-select {
    .ant-form-item {
      margin-bottom: 0;
    }
  }
  .body {
    width: 100%;
    overflow: hidden;
    height: 100%;
    .ant-col,
    .ant-form-item-required {
      width: 100%;
    }
  }
  .footer {
    max-height: 32px;
    /* margin-top: 8px; */
    display: flex;
    align-items: center;
    justify-content: space-between;
    .ant-steps {
      width: 25%;
      .ant-steps-item-wait {
        .ant-steps-item-icon {
          background-color: #d9d9d9;
          border: none;
          .ant-steps-icon {
            color: #fff;
          }
        }
      }
      .ant-steps-item-icon {
        border-radius: 4px;
        margin-right: 0;
      }
    }
    .ant-steps-item {
      padding-left: 0 !important;
      .ant-steps-item-container {
        .ant-steps-item-tail {
          display: block;
          top: 12px;
          left: 14px;
        }
      }
    }
  }
  .tasks-background {
    padding: 16px;
    padding-left: 0;
    padding-bottom: 0;
    background: #f7f8fa;
    border-radius: 8px;
    display: flex;
    flex-wrap: wrap;
    .item {
      width: 33%;
      padding-left: 20px;
      display: flex;
      .ant-input-number-handler-wrap {
        opacity: 1;
      }
      .ant-tree-select .ant-select-selector {
        border-radius: 0;
      }
      .ant-select-multiple .ant-select-selection-item-content {
        font-size: 12px;
      }
    }
  }
`
const TemplateSelect = styled.div`
  padding-right: 10px;
  display: grid;
  justify-content: space-between;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  grid-gap: 0 20px;
  .item {
    width: 100%;
    height: 130px;
    padding: 12px;
    margin-bottom: 16px;
    background: #f7f7f9;
    border-radius: 8px;
    border: 1px solid #d9d9d9;
    .flex {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .ant-checkbox {
        top: 0;
        &:hover::after {
          border-radius: 4px;
        }
      }
      .ant-checkbox-inner {
        width: 24px;
        height: 24px;
        border-radius: 4px !important;
        &::after {
          left: 26.5%;
          width: 6.714286px;
          height: 12.142857px;
          top: 47%;
        }
      }
    }
    .item-main {
      height: 68px;
      background: #ffffff;
      border-radius: 8px;
      margin-top: 10px;
      display: flex;
      .item-img {
        width: 74px;
        padding: 10px 12px;
      }
      .item-right {
        width: calc(100% - 90px);
        height: 68px;
        background: #ffffff;
        border-left: 1px solid #e8e8f0;
        border-radius: 0 8px 8px 0;
        .analysis,
        .bmp {
          height: 32px;
          padding-left: 12px;
          display: flex;
          align-items: center;
        }
        .analysis {
          border-bottom: 1px solid #e8e8f0;
        }
      }
    }
  }
`
const DataContentTemplate = styled.div`
  height: 100%;
  min-height: 500px;
  .content {
    display: flex;
    justify-content: space-between;
    height: 70%;
  }
  .left {
    width: calc(50% - 5px);
    .title {
      font-size: 16px;
      margin-bottom: 16px;
    }
    .left-content {
      height: calc(100% - 32px);
      background: #f8f9fb;
      border-radius: 6px;
      overflow-y: scroll;
      padding: 14px;
      position: relative;
      word-wrap: break-word;
      word-break: break-all;
      overflow-x: hidden;
      padding: 10px;
    }
  }
  .right {
    width: calc(50% - 5px);
    .title {
      font-size: 16px;
      margin-bottom: 16px;
    }
    .right-content {
      height: calc(100% - 35px);
      border-radius: 6px;
      border: 1px solid #d9d9d9;
      overflow-y: scroll;
      padding: 14px;
    }
    .ant-form-item-control {
      width: calc(100% - 140px);
    }
    .ant-form-item-label {
      width: 120px;
      text-align: left;
    }
  }
  .content-footer {
    height: calc(30% - 32px);
    margin-top: 24px;
    .title {
      font-size: 16px;
      margin-bottom: 12px;
    }
    .footer-main {
      height: calc(100% - 32px);
      border-radius: 8px;
      display: grid;
      justify-content: space-between;
      grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
      grid-gap: 0 10px;
      border: 1px solid #d9d9d9;
      padding: 19px;
    }
  }
`
interface BmpButtonProps {
  active: boolean
}
const BmpButton = styled.div<BmpButtonProps>`
  width: 120px;
  height: 32px;
  background: ${props => (props.active ? '#E2E4F6' : '#fff')};
  border-radius: 6px;
  border: 1px solid #c6caee;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-bottom: 10px;
`
const LeakageTemplate = styled.div`
  height: 100%;
  min-height: 460px;
  display: flex;
  justify-content: space-between;
  .left,
  .right {
    width: calc(50% - 5px);
    .title {
      margin-bottom: 16px;
    }
    .content {
      border: 1px solid #d9d9d9;
      border-radius: 6px;
      height: calc(100% - 48px);
      display: flex;
      align-content: space-between;
      flex-wrap: wrap;
      .compress-mode {
        width: 100%;
        display: grid;
        justify-content: space-between;
        grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
        grid-gap: 0 10px;
        padding: 20px;
      }
      .content-footer {
        padding: 14px 20px;
        width: 100%;
        height: 15%;
        min-height: 84px;
        border-top: 1px solid #d9d9d9;
      }
    }
  }
`
const OverviewTemplate = styled.div`
  height: 100%;
  .leakage {
    width: 100%;
    height: 160px;
    background: url(${props => props.cover}) no-repeat;
    background-size: 100% 160px;
    display: flex;
    justify-content: space-around;
    .leakage-left,
    .leakage-center,
    .leakage-right {
      width: 30%;
      height: 100%;
      margin-top: 14px;
      .title {
        font-weight: bold;
        margin-bottom: 16px;
      }
      .leakage-context {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
      }
      .leakage-empty {
        height: calc(100% - 100px);
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .leakage-center .leakage-context {
      padding-left: 10%;
    }
    .leakage-right .leakage-context {
      padding-left: 5%;
    }
  }
  .overview {
    height: 80px;
    background: #f8f9fb;
    border-radius: 8px;
    padding: 18px 20px;
    margin-bottom: 24px;
    display: flex;
    flex-wrap: wrap;
  }
  .flex {
    display: flex;
    width: 33%;
    .title {
      width: 90px;
      color: #666;
    }
  }
`
